function Step2FabHomepageContent({
  templateState,
  setTemplateField,

  heroImageFile,
  setHeroImageFile,
  secondHeroImageFile,
  setSecondHeroImageFile,
  thirdHeroImageFile,
  setThirdHeroImageFile,
  fourthHeroImageFile,
  setFourthHeroImageFile,

  galleryImageFiles,
  setGalleryImageFiles,
  existingGalleryImageUrls,
  setExistingGalleryImageUrls,
  removeGalleryImages,
  setRemoveGalleryImages,

  existingHeroImageUrl,
  existingSecondHeroImageUrl,
  existingThirdHeroImageUrl,
  existingFourthHeroImageUrl,

  removeHeroImage,
  setRemoveHeroImage,
  removeSecondHeroImage,
  setRemoveSecondHeroImage,
  removeThirdHeroImage,
  setRemoveThirdHeroImage,
  removeFourthHeroImage,
  setRemoveFourthHeroImage,
}) {


  return (
    <div className="card">
      <h2>FAB homepage content</h2>

      <div className="row-2">
        <label className="field">
          <span>Hero title</span>
          <input
            value={templateState.hero_title || ""}
            onChange={(e) =>
              setTemplateField("hero_title", e.target.value)
            }
            placeholder="Fast Action Basketball"
          />
        </label>

        <label className="field">
          <span>Hero subtitle</span>
          <input
            value={templateState.hero_subtitle || ""}
            onChange={(e) =>
              setTemplateField("hero_subtitle", e.target.value)
            }
            placeholder="Competition . Community . Camaraderie"
          />
        </label>
      </div>

      <div className="row-2">
        <label className="field">
          <span>Hero button text</span>
          <input
            value={templateState.hero_button_label || ""}
            onChange={(e) =>
              setTemplateField("hero_button_label", e.target.value)
            }
            placeholder="EXPLORE"
            maxLength={30}
          />
        </label>

        <label className="field">
          <span>Hero button link</span>
          <input
            value={templateState.hero_button_link || ""}
            onChange={(e) =>
              setTemplateField("hero_button_link", e.target.value)
            }
            placeholder="/fastactionbasketball/leagueInfo or https://..."
          />
        </label>
      </div>

      <div className="field">
        <span>Main hero image</span>

        {existingHeroImageUrl && !heroImageFile && !removeHeroImage ? (
          <div className="existing-file-row">
            <span className="existing-file-pill">Current hero image uploaded</span>
            <a
              href={existingHeroImageUrl}
              target="_blank"
              rel="noreferrer"
              className="existing-file-link"
            >
              View
            </a>
            <button
              type="button"
              className="existing-file-remove"
              onClick={() => {
                setRemoveHeroImage(true);
                setHeroImageFile(null);
              }}
            >
              Remove
            </button>
          </div>
        ) : null}

        {removeHeroImage ? (
          <div className="existing-file-row">
            <span className="existing-file-pill">Hero image will be removed</span>
            <button
              type="button"
              className="existing-file-link"
              onClick={() => setRemoveHeroImage(false)}
            >
              Undo
            </button>
          </div>
        ) : null}

        <div className="file-row">
          <input
            id="fab-hero-upload"
            type="file"
            accept="image/*"
            className="file-hidden"
            onChange={(e) => {
              const file = e.target.files?.[0] || null;
              setHeroImageFile(file);
              if (file) setRemoveHeroImage(false);
            }}
          />
          <label htmlFor="fab-hero-upload" className="file-btn">
            Choose File
          </label>
          <div className="file-name">{heroImageFile?.name || "No file chosen"}</div>
        </div>
      </div>

      <label className="field">
        <span>Intro text</span>
        <textarea
          value={templateState.intro_text || ""}
          onChange={(e) =>
            setTemplateField("intro_text", e.target.value)
          }
          className="textarea"
          rows={4}
          placeholder="Fast Action Basketball is Southern California's Premier Adult League..."
        />
      </label>

      <div className="field">
        <span>Gallery images</span>

        {Array.isArray(existingGalleryImageUrls) &&
          existingGalleryImageUrls.length > 0 &&
          !removeGalleryImages ? (
          <div className="gallery-file-list">
            {existingGalleryImageUrls.map((url, index) => (
              <div key={`${url}-${index}`} className="existing-file-row">
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="existing-file-pill"
                >
                  Gallery image {index + 1}
                </a>
                <button
                  type="button"
                  className="existing-file-remove"
                  onClick={() => {
                    setExistingGalleryImageUrls((prev) =>
                      prev.filter((_, i) => i !== index)
                    );
                  }}
                >
                  Remove
                </button>
              </div>
            ))}

            <button
              type="button"
              className="existing-file-remove"
              onClick={() => {
                setRemoveGalleryImages(true);
                setGalleryImageFiles([]);
              }}
            >
              Remove All
            </button>
          </div>
        ) : null}

        {removeGalleryImages ? (
          <div className="existing-file-row">
            <span className="existing-file-pill">Gallery images will be removed</span>
            <button
              type="button"
              className="existing-file-link"
              onClick={() => setRemoveGalleryImages(false)}
            >
              Undo
            </button>
          </div>
        ) : null}

        <div className="file-row">
          <input
            id="fab-gallery-upload"
            type="file"
            accept="image/*"
            multiple
            className="file-hidden"
            onChange={(e) => {
              const files = Array.from(e.target.files || []);

              setGalleryImageFiles((prev) => [...prev, ...files]);
              if (files.length > 0) setRemoveGalleryImages(false);

              e.target.value = "";
            }}
          />
          <label htmlFor="fab-gallery-upload" className="file-btn">
            Choose Files
          </label>
          <div className="file-name">
            {galleryImageFiles?.length
              ? `${galleryImageFiles.length} file(s) selected`
              : "No files chosen"}
          </div>
        </div>

        {galleryImageFiles?.length > 0 ? (
          <div className="gallery-file-list">
            {galleryImageFiles.map((file, index) => (
              <div key={`${file.name}-${index}`} className="existing-file-row">
                <span className="existing-file-pill">{file.name}</span>
                <button
                  type="button"
                  className="existing-file-remove"
                  onClick={() => {
                    setGalleryImageFiles((prev) =>
                      prev.filter((_, i) => i !== index)
                    );
                  }}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        ) : null}
      </div>

      <div className="field">
        <span>Second hero image</span>

        {existingSecondHeroImageUrl && !secondHeroImageFile && !removeSecondHeroImage ? (
          <div className="existing-file-row">
            <span className="existing-file-pill">Current second hero image uploaded</span>
            <a
              href={existingSecondHeroImageUrl}
              target="_blank"
              rel="noreferrer"
              className="existing-file-link"
            >
              View
            </a>
            <button
              type="button"
              className="existing-file-remove"
              onClick={() => {
                setRemoveSecondHeroImage(true);
                setSecondHeroImageFile(null);
              }}
            >
              Remove
            </button>
          </div>
        ) : null}

        {removeSecondHeroImage ? (
          <div className="existing-file-row">
            <span className="existing-file-pill">Second hero image will be removed</span>
            <button
              type="button"
              className="existing-file-link"
              onClick={() => setRemoveSecondHeroImage(false)}
            >
              Undo
            </button>
          </div>
        ) : null}

        <div className="file-row">
          <input
            id="fab-second-hero-upload"
            type="file"
            accept="image/*"
            className="file-hidden"
            onChange={(e) => {
              const file = e.target.files?.[0] || null;
              setSecondHeroImageFile(file);
              if (file) setRemoveSecondHeroImage(false);
            }}
          />
          <label htmlFor="fab-second-hero-upload" className="file-btn">
            Choose File
          </label>
          <div className="file-name">{secondHeroImageFile?.name || "No file chosen"}</div>
        </div>
      </div>

      <label className="field">
        <span>Section two text</span>
        <textarea
          value={templateState.section_two_text || ""}
          onChange={(e) =>
            setTemplateField("section_two_text", e.target.value)
          }
          className="textarea"
          rows={5}
        />
      </label>

      <div className="field">
        <span>Third hero image</span>

        {existingThirdHeroImageUrl && !thirdHeroImageFile && !removeThirdHeroImage ? (
          <div className="existing-file-row">
            <span className="existing-file-pill">Current third hero image uploaded</span>
            <a
              href={existingThirdHeroImageUrl}
              target="_blank"
              rel="noreferrer"
              className="existing-file-link"
            >
              View
            </a>
            <button
              type="button"
              className="existing-file-remove"
              onClick={() => {
                setRemoveThirdHeroImage(true);
                setThirdHeroImageFile(null);
              }}
            >
              Remove
            </button>
          </div>
        ) : null}

        {removeThirdHeroImage ? (
          <div className="existing-file-row">
            <span className="existing-file-pill">Third hero image will be removed</span>
            <button
              type="button"
              className="existing-file-link"
              onClick={() => setRemoveThirdHeroImage(false)}
            >
              Undo
            </button>
          </div>
        ) : null}

        <div className="file-row">
          <input
            id="fab-third-hero-upload"
            type="file"
            accept="image/*"
            className="file-hidden"
            onChange={(e) => {
              const file = e.target.files?.[0] || null;
              setThirdHeroImageFile(file);
              if (file) setRemoveThirdHeroImage(false);
            }}
          />
          <label htmlFor="fab-third-hero-upload" className="file-btn">
            Choose File
          </label>
          <div className="file-name">{thirdHeroImageFile?.name || "No file chosen"}</div>
        </div>
      </div>

      <label className="field">
        <span>Section three text</span>
        <textarea
          value={templateState.section_three_text || ""}
          onChange={(e) =>
            setTemplateField("section_three_text", e.target.value)
          }
          className="textarea"
          rows={4}
        />
      </label>

      <div className="field">
        <span>Fourth hero image</span>

        {existingFourthHeroImageUrl && !fourthHeroImageFile && !removeFourthHeroImage ? (
          <div className="existing-file-row">
            <span className="existing-file-pill">Current fourth hero image uploaded</span>
            <a
              href={existingFourthHeroImageUrl}
              target="_blank"
              rel="noreferrer"
              className="existing-file-link"
            >
              View
            </a>
            <button
              type="button"
              className="existing-file-remove"
              onClick={() => {
                setRemoveFourthHeroImage(true);
                setFourthHeroImageFile(null);
              }}
            >
              Remove
            </button>
          </div>
        ) : null}

        {removeFourthHeroImage ? (
          <div className="existing-file-row">
            <span className="existing-file-pill">Fourth hero image will be removed</span>
            <button
              type="button"
              className="existing-file-link"
              onClick={() => setRemoveFourthHeroImage(false)}
            >
              Undo
            </button>
          </div>
        ) : null}

        <div className="file-row">
          <input
            id="fab-fourth-hero-upload"
            type="file"
            accept="image/*"
            className="file-hidden"
            onChange={(e) => {
              const file = e.target.files?.[0] || null;
              setFourthHeroImageFile(file);
              if (file) setRemoveFourthHeroImage(false);
            }}
          />
          <label htmlFor="fab-fourth-hero-upload" className="file-btn">
            Choose File
          </label>
          <div className="file-name">{fourthHeroImageFile?.name || "No file chosen"}</div>
        </div>
      </div>

      <label className="field">
        <span>Section four lines</span>
        <textarea
          value={templateState.section_four_text || ""}
          onChange={(e) =>
            setTemplateField("section_four_text", e.target.value)
          }
          className="textarea"
          rows={6}
          placeholder={`Line 1\nLine 2\nLine 3\nLine 4`}
        />
        <div className="muted small">One line per row.</div>
      </label>
    </div>
  );
}

export default Step2FabHomepageContent;